export class State {
	public constructor(public readonly id: string, public readonly name: string, public readonly countryId: string) {}
}
